import { getInitialsFromAccount, getTitleFromAccount } from '@gn-audio/core/auth/uip/utilities';
import { getWebStoreApiClient } from '@gn-audio/core/auth/web-store-api/client';

export interface WebstoreAccountDetails {
  initials: string;
  title: string;
}

export const getAccountDetails = async (): Promise<WebstoreAccountDetails | undefined> => {
  const webstoreClient = getWebStoreApiClient();

  await webstoreClient.onTokenAcquired;

  const account = webstoreClient.account;
  if (!account) {
    return undefined;
  }

  return {
    initials: getInitialsFromAccount(account),
    title: getTitleFromAccount(account),
  };
};
